import { createContext } from 'react'

export type BackHistoryRegister = (onBack: () => void | false) => () => void
export type BackHistoryContext = {
	readonly register: BackHistoryRegister
	readonly isTransitioning: () => boolean
	readonly setTransitioning: (isTransitioning: boolean) => void
}
export const BackHistoryCtx = createContext<BackHistoryContext>(null as any)
